import AuthenticationInitializer from './authentication';
import { ExperimentationProvider } from './experimentation';
import LocalizationContextProvider from './localization';
import ModalContextProvider from './modal';
import { EagerLoadingContextProvider } from './eager-loading';
import GlobalModalListener from './modal/GlobalModalListener';

import type { IRootContextProvider } from './types';

const RootContextProvider = ({
  children,
  includeExperimentation,
}: IRootContextProvider) => (
  <EagerLoadingContextProvider eagerLoad={false}>
    <AuthenticationInitializer />
    <LocalizationContextProvider>
      <ModalContextProvider>
        <GlobalModalListener />
          <ExperimentationProvider includeExperimentation={includeExperimentation}>
            {children}
          </ExperimentationProvider>
      </ModalContextProvider>
    </LocalizationContextProvider>
  </EagerLoadingContextProvider>
);

export default RootContextProvider;
